import { render, staticRenderFns } from "./ShoppingBasketCounter.vue?vue&type=template&id=1e4d5584&scoped=true&"
import script from "./ShoppingBasketCounter.vue?vue&type=script&lang=js&"
export * from "./ShoppingBasketCounter.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingBasketCounter.vue?vue&type=style&index=0&id=1e4d5584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4d5584",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e4d5584')) {
      api.createRecord('1e4d5584', component.options)
    } else {
      api.reload('1e4d5584', component.options)
    }
    module.hot.accept("./ShoppingBasketCounter.vue?vue&type=template&id=1e4d5584&scoped=true&", function () {
      api.rerender('1e4d5584', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/ShoppingBasketCounter.vue"
export default component.exports